/**
 * Blossom — newsletter.js
 * <newsletter-form> — enhances snippets/newsletter-form.liquid.
 *
 * Newsletter forms post to Shopify and the page reloads with the form's
 * success/error state. Because every customer form on the page receives that
 * state, this element remembers which form was submitted (Theme.storage) and
 * hides the status everywhere else, then moves focus to the right message.
 * It also shows a loading state while the form posts.
 */
(() => {
  if (!window.Theme || customElements.get('newsletter-form')) return;

  const STORAGE_KEY = 'theme:newsletter:submitted';
  const MAX_AGE = 5 * 60 * 1000;

  Theme.newsletter = {
    /** The most recent submission { id, time } if it happened in the last few minutes. */
    lastSubmission() {
      const record = Theme.storage.get(STORAGE_KEY);
      if (!record || !record.id || Date.now() - Number(record.time) > MAX_AGE) return null;
      return record;
    },
  };

  class NewsletterForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form || this.bound) return;
      this.bound = true;

      this.form.addEventListener('submit', () => {
        Theme.storage.set(STORAGE_KEY, { id: this.form.id, time: Date.now() });
        const button = this.form.querySelector('[type="submit"]');
        if (button) {
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
        }
      });

      this.reconcileStatus();
    }

    reconcileStatus() {
      const status = this.querySelector('[data-newsletter-status]');
      if (!status) return;
      const record = Theme.newsletter.lastSubmission();
      if (!record) return;

      const input = this.form.querySelector('input[type="email"]');

      if (record.id !== this.form.id) {
        // Another newsletter form on this page was submitted.
        status.hidden = true;
        input?.removeAttribute('aria-invalid');
        input?.removeAttribute('aria-describedby');
        return;
      }

      // Forms inside a closed dialog (popup) are focused by their dialog.
      const dialog = this.closest('dialog');
      if (dialog && !dialog.open) return;

      requestAnimationFrame(() => {
        if (status.hasAttribute('data-newsletter-success')) status.focus();
        else input?.focus();
      });
    }
  }

  customElements.define('newsletter-form', NewsletterForm);
})();
